import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Accessibility } from "lucide-react";
import { NAV_LINKS, SITE, PRODUCTS, SERVICES } from "@/data/site";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#001529] text-slate-300 blueprint-grid">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <p className="text-sm leading-relaxed text-slate-400">
              Vision Building Systems, L.L.C. is a Florida company serving the Southeastern United States in the
              sale, delivery, and installation of modular buildings — from small and simple to large and complex.
            </p>
          </div>

          <nav aria-label="Footer">
            <h3 className="font-heading font-bold text-white text-sm uppercase tracking-[0.18em] mb-5">
              Explore
            </h3>
            <ul className="space-y-2.5 text-sm">
              {NAV_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    data-testid={`footer-${link.testId}`}
                    className="hover:text-amber-500 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/accessibility-statement"
                  data-testid="footer-accessibility-link"
                  className="inline-flex items-center gap-2 hover:text-amber-500 transition-colors duration-200"
                >
                  <Accessibility className="h-4 w-4" aria-hidden="true" />
                  Accessibility Statement
                </Link>
              </li>
            </ul>
          </nav>

          <div>
            <h3 className="font-heading font-bold text-white text-sm uppercase tracking-[0.18em] mb-5">
              Products & Services
            </h3>
            <ul className="space-y-2.5 text-sm text-slate-400">
              {PRODUCTS.slice(0, 3).map((p) => (
                <li key={p}>{p}</li>
              ))}
              {SERVICES.slice(0, 3).map((s) => (
                <li key={s}>{s}</li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-bold text-white text-sm uppercase tracking-[0.18em] mb-5">
              Contact
            </h3>
            <ul className="space-y-3.5 text-sm">
              <li>
                <a
                  href={SITE.phoneHref}
                  data-testid="footer-phone-link"
                  className="inline-flex items-center gap-2.5 hover:text-amber-500 transition-colors duration-200"
                >
                  <Phone className="h-4 w-4 text-amber-500" aria-hidden="true" />
                  {SITE.phone}
                </a>
              </li>
              {SITE.emails.map((e) => (
                <li key={e.address}>
                  <a
                    href={`mailto:${e.address}`}
                    data-testid={`footer-email-${e.address}`}
                    className="inline-flex items-center gap-2.5 hover:text-amber-500 transition-colors duration-200"
                  >
                    <Mail className="h-4 w-4 text-amber-500" aria-hidden="true" />
                    {e.address}
                  </a>
                </li>
              ))}
              <li className="flex items-start gap-2.5 text-slate-400">
                <MapPin className="h-4 w-4 text-amber-500 mt-0.5 shrink-0" aria-hidden="true" />
                {SITE.serviceArea}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-400">
          <p data-testid="footer-copyright">© 2026 Vision Building Systems, L.L.C. All rights reserved.</p>
          <p data-testid="footer-credit">
            Website Designed By{" "}
            <a
              href="https://bp.agency"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-brand-partners-link"
              className="font-bold text-white hover:text-amber-500 transition-colors duration-200"
            >
              Brand Partners
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
